import { useMutation } from "@tanstack/react-query";
import { createClef } from "../api/CLEF/clef";

export function useCreateApiKey() {
  return useMutation({
    mutationFn: createClef,
  });
}
